import { useMutation } from '@tanstack/react-query';
import { osmPost } from '@/api/osmClient';
import type { IsochroneFeatureCollection, IsochroneRequest } from '@/types/osm';

export function useOsmIsochrone() {
  return useMutation<IsochroneFeatureCollection, Error, IsochroneRequest>({
    mutationFn: (req) =>
      osmPost<IsochroneFeatureCollection, IsochroneRequest>('/isochrone', req),
  });
}
